import { TestConfigStep } from '../test-config-steps-provider.interfaces';

export const getNextUncompletedStepIndex = (currentStepIndex: number, steps: TestConfigStep[]) => {
  let nextIndex = currentStepIndex + 1;

  while (nextIndex <= steps.length - 1) {
    if (!steps[nextIndex].isCompleted) {
      break;
    }
    nextIndex++;
  }
  return nextIndex;
};
